import type {NoticeProps} from 'chakra-react-select';
import {components} from 'chakra-react-select';

const ChakraNoOptionsMessage = components.NoOptionsMessage;

export const NoOptionsMessage = (props: NoticeProps<any, any, any>) => {
  return <ChakraNoOptionsMessage {...props} />;
};
